<template>
    <modal v-model="showModal" @hidden="onHide" size="regular">
        <template slot="header">
            <div>
                <h2 class="display-4 montserrat-bold mt-4 mb-0" v-text="shopService.name"></h2>
                <div class="mt--2 heading-small" v-text="subtitle"></div>
            </div>
        </template>
        <div class="row">
            <div class="col-lg-12 mb-4">
                <h3 class="text-default text-sm" v-text="shopService.description"></h3>
            </div>
            <div class="col-lg-4 col-sm-12">
                <div class="text-xs">Duration</div>
                <h3 class="font-weight-700 text-default text-sm" v-text="shopService.duration"></h3>
            </div>
            <div class="col-lg-4 col-sm-12">
                <div class="text-xs">Price</div>
                <h3 class="font-weight-700 text-default text-sm" v-text="shopService.price"></h3>
            </div>
            <div v-if="isPackage && isRequesting" class="col-sm-12 mt-4">
                <div class="text-xs mb-2">Pacakge Items</div>
                <div class="font-weight-500">
                    <i class="fa fa-spinner fa-spin mr-2"></i> Loading package items
                </div>
            </div>
            <div v-else-if="isPackage" class="col-sm-12 mt-4">
                <div class="text-xs">Pacakge Items</div>
                <div v-for="(packageItem, key) in packageItems" :key="key" class="package-item-wrapper row">
                    <div class="col-6">
                        <div class="text-xs" v-text="(packageItem.subcategory || {}).name"></div>
                        <h3 class="font-weight-700 text-default text-sm mb--1" v-text="getPackageItemDisplayName(packageItem)"></h3>
                    </div>
                    <div class="col-6">
                        <div class="text-xs">Duration</div>
                        <h3 class="font-weight-700 text-default text-sm mb--1" v-text="getDisplayedDuration(packageItem)"></h3>
                    </div>
                </div>
            </div>
        </div>
    </modal>
</template>
<script>
import mixins from '@utils/mixins';
import { get, route } from '@utils/network';
import { getDisplayedDuration } from "@utils/helpers";

export default {
    name: 'ServiceModal',

    computed: {
        subcategory() {
            return this.shopService.subcategory || {};
        },
        isPackage() {
            return this.shopService.type === "package";
        },
        subtitle() {
            return !this.isPackage
                ? `${ this.shopService.type } - ${ this.subcategory.name }`
                : `${ this.shopService.type }`;
        },
        packageItems() {
            return this.shopService.packageItems || [];
        },
    },

    data: () => ({
        showModal: false,
        clearModal: true,
        isRequesting: false,
        shopService: {},
    }),

    methods: {
        getPackageItemDisplayName(packageItem) {
            return `${ packageItem.quantity || 1 }x ${ packageItem.name }`
        },
        getDisplayedDuration(service) {
            return getDisplayedDuration(service.duration || 0);
        },
        clearFields() {
            this.shopService = {};
        },

        show(shopService) {
            this.showModal = true;
            this.shopService = {...shopService};
            if (shopService.type === "package") {
                this.fetchPackageItems();
            }
        },

        onHide() {
            this.showModal = false;
            if (this.clearModal) {
                this.clearFields();
            }
        },


        fetchPackageItems() {
            this.isRequesting = true;
            get(route("shops/package-items"), { params: { package_id: this.shopService.id } })
                .then(response => this.shopService.packageItems = response.data.result.packageItems)
                .catch(error => {
                    console.log(error);
                    this.promptErrors(error.response.data.message);
                })
                .finally(() => this.isRequesting = false);
        }
    },

    mixins: [ mixins ],

    mounted() {
    }
}
</script>
<style lang="css" scoped>
    .package-item-wrapper {
        padding: 1rem 0 0!important;
    }
    .package-item-wrapper::after {
        content: " ";
        width: 100%;
        padding-top: 1rem;
        display: block;
        margin: 0px 15px;
        border-bottom: 1px solid rgba(0,0,0,0.1);
    }
</style>